import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import avatar1 from "../../assets/img/avatars/2.png";
import avatar2 from "../../assets/img/avatars/4.png";
import { postList,deletePost } from "../../common/api";
import { ShowToast } from "../../common/function";
import { format } from "date-fns";
import { Sentry, Spinner } from "react-activity";
export default function Posts() {
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [postId, setPostId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (postId) => {
    setShow(true);
    setPostId(postId);
  };
  const [postListData, setPostListData] = useState([]);
  const getPostList = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const response = await postList(token, {});
    if (response.success) {
      setLoading(false);
      setPostListData(response.body);
    } else {
      ShowToast(0, response.message || "Post list failed");
    }
  };
  useEffect(() => {
    getPostList();
  }, []);

  console.log("postListData", postListData);
    const formatDate = (dateString) => {
      return dateString?format(new Date(dateString), "dd-MM-yyyy"):"N/A";
    };


  const getStatusStyle = (status) => {
    switch (status) {
      case "0":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
        
      case undefined:
        return {
          backgroundColor: "rgba(255, 0, 0, 0.12)",
          color: "#ff0000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };  
      default:
        return {};
    }
  };

  
  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row,index) => index+1,
      sortable: true,
      cell: (row,index) => index+1,
    },
    {
      name: "Added By",
      minWidth: "220px",
      selector: (row) => row?.userDetail?.full_name,
      sortable: true,
      cell: (row) => <>{row?.userDetail?.full_name?row?.userDetail?.full_name:"N/A"}</>,
    },
    {
      name: "Date",
      minWidth: "190px",
      selector: (row) => row?.createdAt,
      sortable: true,
      cell: (row) => row?.createdAt?formatDate(row?.createdAt):"N/A",
    },
    {
      name: "User Status",
      minWidth: "190px",
      selector: (row) => row?.userDetail?.is_deleted,
      sortable: true,
      cell: (row) => (
        <>
                  <span style={getStatusStyle(row?.userDetail?.is_deleted)}>
                  {row?.userDetail?.is_deleted == "0" ? "Active" : row?.userDetail==null?"Deleted":"N/A"}
        </span>
        </>
      ),
    },
    {
      name: "Description",
      minWidth: "190px",
      selector: (row) => row?.about_post,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            paddingRight: "8px"
          }}
        >
        {row?.about_post ? row?.about_post : "N/A"}
        </div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btnview" to="/posts/view-post" state={{ postId: row._id }}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btnedit" to="/posts/edit-post" state={{ postId: row._id }}>
            <Icon icon="tabler:pencil"></Icon>
          </Link>
          <Link className="btndelete" onClick={()=>handleShow(row._id)}>
            <Icon icon="tabler:trash"></Icon>
          </Link>
        </>
      ),
    },
  ];
  const [data] = useState([
    {
      id: 1,
      name: "Laila",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Great content!",
      description: "Actively engages with followers.",
    },
    {
      id: 2,
      name: "Mai My Oanh",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Very interactive.",
      description: "Focuses on lifestyle and health topics.",
    },
    {
      id: 3,
      name: "Zaire Hassan",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Shares useful insights.",
      description: "Promotes educational content.",
    },
    {
      id: 4,
      name: "Kianna Rhiel Madsen",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Posts regularly.",
      description: "Creates visually engaging posts.",
    },
    {
      id: 5,
      name: "Rayna Lubin",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Lots of Q&A.",
      description: "Engages in community discussions.",
    },
    {
      id: 6,
      name: "Zaire Kenter",
      imgurl: avatar2,
      date: "2024-01-01",
      comments: "Friendly and open.",
      description: "Supports mental wellness.",
    },
    {
      id: 7,
      name: "Jaxson Korsgaard",
      imgurl: avatar1,
      date: "2024-01-01",
      comments: "Growing quickly.",
      description: "New content creator in tech niche.",
    },
  ]);
  // Filter data based on search text
  const filteredData = postListData&&postListData.length>0?postListData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !==
      -1
  ):[];

  const handleDelete = async (postId) => {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    const response = await deletePost(token, { postId });
    setIsLoading(false)
    if(response.success){
      ShowToast(1,"Post deleted successfully");
      getPostList();
      handleClose();
    }else{
      ShowToast(0,response.message);
    }

  };
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between py-4">
              <h5>Posts</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? ( <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                data={filteredData}
                pagination
                responsive
                className="custom-table"
              />
              )}

            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={()=>handleDelete(postId)}

          >
            { isLoading ? (
              <Spinner animation="border" variant="primary" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
